(function() {

  // Below are example event listeners. They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Global Arrow Replacement for Flickity Carousels
  // Replaces default Flickity arrow icons with custom TDP Co. arrow SVG
  document.addEventListener('DOMContentLoaded', function() {
    // CSS handles the visual replacement via ::before pseudo-elements
    // This ensures any dynamically created carousels also get the treatment
  });

  // ── WCAG Accessibility: Keyboard navigation for header dropdown menus ──
  // Global scope: runs on all pages
  document.addEventListener('DOMContentLoaded', function() {

    var menuItems = document.querySelectorAll('.menu__item[role="button"][tabindex="0"]');
    if (!menuItems.length) return;

    menuItems.forEach(function(item) {
      var dropdown = item.querySelector('.header__dropdown');
      if (!dropdown) return;

      // Show dropdown and add is-visible when menu item receives keyboard focus
      item.addEventListener('focusin', function() {
        if (!item.classList.contains('keyboard-closed')) {
          dropdown.classList.add('is-visible');
          item.classList.add('is-visible');
          item.setAttribute('aria-expanded', 'true');
        }
      });

      // Hide dropdown when focus leaves the menu item entirely
      item.addEventListener('focusout', function() {
        setTimeout(function() {
          if (!item.contains(document.activeElement)) {
            item.classList.remove('keyboard-closed');
            dropdown.classList.remove('is-visible');
            item.classList.remove('is-visible');
            item.setAttribute('aria-expanded', 'false');
          }
        }, 50);
      });

      // Enter/Space toggles the dropdown (only when the menu item itself is focused)
      item.addEventListener('keydown', function(e) {
        if (e.target !== item) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          var isClosed = item.classList.contains('keyboard-closed');

          if (isClosed) {
            // Open the dropdown
            item.classList.remove('keyboard-closed');
            dropdown.classList.add('is-visible');
            item.classList.add('is-visible');
            item.setAttribute('aria-expanded', 'true');
            var firstLink = dropdown.querySelector('a');
            if (firstLink) {
              setTimeout(function() { firstLink.focus(); }, 50);
            }
          } else {
            // Close the dropdown
            item.classList.add('keyboard-closed');
            dropdown.classList.remove('is-visible');
            item.classList.remove('is-visible');
            item.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });

    // Escape key: close any open dropdown and return focus to the trigger
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;

      var focusedItem = null;
      menuItems.forEach(function(item) {
        if (item.contains(document.activeElement)) {
          focusedItem = item;
        }
      });

      if (focusedItem) {
        var dd = focusedItem.querySelector('.header__dropdown');
        if (dd) {
          dd.classList.remove('is-visible');
          focusedItem.classList.remove('is-visible');
          focusedItem.setAttribute('aria-expanded', 'false');
        }
        focusedItem.classList.add('keyboard-closed');
        focusedItem.focus();
      }
    });
  });

  // ── WCAG Accessibility: Instagram feed tab order management ──
  // Removes 100+ unnecessary tab stops from Instafeed carousel items
  function fixInstafeedTabOrder() {
    var items = document.querySelectorAll('.instafeed-new-layout-item-container');
    if (!items.length) return false;

    items.forEach(function(item) {
      item.setAttribute('tabindex', '-1');
      item.setAttribute('aria-hidden', 'true');
    });

    document.querySelectorAll('.instafeed-close-button').forEach(function(btn) {
      btn.setAttribute('tabindex', '-1');
    });

    document.querySelectorAll('.instafeed-new-arrow').forEach(function(arrow, idx) {
      if (!arrow.getAttribute('aria-label')) {
        arrow.setAttribute('aria-label', idx === 0 ? 'Previous Instagram photos' : 'Next Instagram photos');
      }
    });

    return true;
  }

  // App injects content dynamically — retry until found
  var instafeedTimer = setInterval(function() {
    if (fixInstafeedTabOrder()) {
      clearInterval(instafeedTimer);
    }
  }, 500);
  setTimeout(function() { clearInterval(instafeedTimer); }, 10000);

  // ── WCAG Accessibility: Cart drawer aria-hidden management ──
  // Toggles aria-hidden so screen readers don't read closed drawer content
  document.addEventListener('DOMContentLoaded', function() {
    var cartDrawer = document.getElementById('drawer-cart');
    if (!cartDrawer) return;

    cartDrawer.addEventListener('theme:drawer:open', function() {
      cartDrawer.setAttribute('aria-hidden', 'false');
    });

    cartDrawer.addEventListener('theme:drawer:close', function() {
      cartDrawer.setAttribute('aria-hidden', 'true');
    });
  });

})();
